export default __webpack_public_path__ + "static/media/MJMB.5cd3a612.mp4";